
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {
    ApplicationActions, DocumentDuplicateDetailsModel, EditDocumentDuplicateSeedRequest,
    EditDocumentSeedRequest,
} from "@/api-client";
import IssueDocumentInnerComponent
    from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
import DatePicker from "@/components/DatePicker.vue";
import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";

@Component({
    components: {
        DatePicker,
        AdditionalInfoButton,
        LabelOptional
    }
})
export default class IssueDocumentDuplicate extends IssueDocumentInnerComponent {
    @Prop({required: true})
    issueDocumentDetails!: DocumentDuplicateDetailsModel;
    
    @Prop({required: true})
    actions!: ApplicationActions;

    additionalInfo = this.issueDocumentDetails.additionalInfo;
    initialEditModel = this.getEditModel();
    
    getEditModel(): EditDocumentSeedRequest {
        return new EditDocumentDuplicateSeedRequest({ additionalInfo: this.additionalInfo });
    }
}
